import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import posed from 'react-pose';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { authInput, verifySignInThenChangeEmail } from '../store/actions';

const WrapperDiv = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 100px auto 75px;
  grid-row-gap: 5rem;
  grid-template-areas:
    'header header header'
    'body body body'
    'footer footer footer';
  @media (max-width: 700px) {
    grid-row-gap: 0;
  }
`;

const BodyWrapper = styled.div`
  grid-area: body;
  text-align: center;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - (175px + 10rem));
  @media (max-width: 700px) {
    min-height: calc(100vh - 175px);
  }
`;

const StyledInputLabel = styled.label`
  margin-left: 1rem;
  padding: 0;
`;

const TextInput = styled.input`
  margin: 1rem;
  padding: 0;
  width: 22rem;
  height: 3rem;
  border-radius: 3rem;
  border: none;
  text-indent: 1rem
  font-size: 1.5rem;
  &:focus {
    outline: none;
  }
  @media (max-width: 700px) {
    width: 18rem;
    }
`;

const StyledSignupLoginButton = styled.button`
  color: white;
  background-color: ${props => props.color};
  margin: 1rem;
  width: 22rem;
  height: 3rem;
  border-radius: 3rem;
  border: none;
  font-size: 1rem;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.5;
  }
  @media (max-width: 700px) {
    width: 18rem;
  }
`;

const BodyText = styled.p`
    font-family: 'Open Sans', sans-serif;
    > strong {
        color: white
        font-size: 2rem;
        @media (max-width: 700px) {
            font-size: 1.5rem;
            }
    }
`;

const HeaderTextconfig = {
  visible: { opacity: 1, scale: 1 },
  hidden: { opacity: 0, scale: 0 },

  transition: { duration: 0 },
};

const PosedHeaderText = posed.div(HeaderTextconfig);

class SignIn extends Component {
  state = { visible: true, displaySearchResults: false };

  componentDidMount() {
    console.log('test');
  }

  _handleEnterButton = e => {
    if (e.key === 'Enter') {
      if (!this.props.auth.updateEmailPending) {
        this.props.verifySignInThenChangeEmail();
      }
    }
  };

  _sendPasswordReset = () => {
    if (!this.props.auth.updateEmailPending) {
      this.props.verifySignInThenChangeEmail();
    }
  };

  render() {
    const { displaySearchResults } = this.state;

    return (
      <WrapperDiv>
        <Header />
        <BodyWrapper>
          <PosedHeaderText pose={!displaySearchResults ? 'visible' : 'hidden'}>
            <BodyText>
              <strong>
                {this.props.auth.updateEmailSuccess ? "Thanks. Your e-mail's been updated" : "What's your new e-mail?"}
              </strong>
            </BodyText>
          </PosedHeaderText>

          {!this.props.auth.updateEmailSuccess && (
            <Fragment>
              <StyledInputLabel htmlFor="oldEmail">Current E-mail</StyledInputLabel>
              <TextInput
                id="oldEmail"
                placeholder="Old Email"
                onChange={this.props.authInput}
                value={this.props.auth.oldEmail}
                name="oldEmail"
                type="email"
              />
              <StyledInputLabel htmlFor="newEmail">New email</StyledInputLabel>
              <TextInput
                id="newEmail"
                placeholder="New Email"
                onChange={this.props.authInput}
                value={this.props.auth.newEmail}
                onKeyPress={this._handleEnterButton}
                name="newEmail"
                type="email"
              />
              <StyledSignupLoginButton
                color="red"
                onClick={this._sendPasswordReset}
                disabled={this.props.auth.updateEmailPending ? 'disabled' : ''}
              >
                CHANGE MY E-MAIL!
              </StyledSignupLoginButton>
            </Fragment>
          )}
        </BodyWrapper>
        <Footer />
      </WrapperDiv>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { authInput, verifySignInThenChangeEmail }
)(SignIn);



// WEBPACK FOOTER //
// ./src/screen/SignIn.js